import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';
import { type ReactNode } from 'react';

type Props = CommonTemplateProps & {
  readonly ariaLabel: string;
  readonly content: ReactNode;
  readonly heading: ReactNode;
};

export const MoreReviewsModal = ({
  ariaLabel,
  closeModal,
  content,
  heading,
  isOpen,
}: Props) => {
  return (
    <ModalTemplateWrapper
      ariaLabel={ariaLabel}
      ctaOptions={{
        primaryCTA: undefined,
        secondaryCTA: undefined,
      }}
      desktopModalSize="md"
      headerText={heading}
      isOpen={isOpen}
      onClose={closeModal}
      subheaderText={content}
    />
  );
};
